<template>
  <div class="home uk-container">
    <div class="sign uk-section uk-position-center">
      <div class="home-sign-text uk-flex uk-flex-center">
        <span class="sign-1">JACK</span><span class="sign-1">CARPENTER</span><span class="sign-2">.DEV</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {}
}
</script>
